import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Least frequent element in an Array",
  url: "least-frequent-element-array",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {Any[]} arr
* @return {Any}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function leastFrequent(arr) {
  // your code goes here        
};
`,
};

export default info;
